<template>
  <div>
    <q-form ref="editForm">
      <div class="row">
        <!-- 2차심사 -->
        <c-card title="2차심사" class="cardClassDetailForm">
          <template slot="card-button">
            <q-btn-group outline >
              <!-- 2차심사 보고서 -->
              <c-btn 
                v-show="editable && !disabledPrint && disabled"
                :editable="editable"
                label="2차심사 보고서" 
                icon="print"
                @btnClicked="secondAuditPrint" />
              <!--저장-->
              <c-btn
                v-show="editable && !disabled"
                :url="saveUrl"
                :isSubmit="isSave"
                :param="param.suggestion"
                mappingType="PUT"
                label="LBLSAVE"
                icon="save"
                @beforeAction="saveData"
                @btnCallback="saveCallback" />
              <c-btn
                v-show="editable && !disabled"
                :url="completeUrl"
                :isSubmit="isComplete"
                :param="param.suggestion"
                mappingType="PUT"
                label="완료"
                icon="check"
                @beforeAction="completeData"
                @btnCallback="completeCallback" />
            </q-btn-group>
          </template>
          <template slot="card-detail">
            <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
              <c-select
                required
                :editable="editable"
                :disabled="disabled"
                type="edit"
                codeGroupCd="SAI_SUGGESTION_SECOND_AUDIT_CD"
                itemText="codeName"
                itemValue="code"
                name="suggestionSecondAuditCd"
                label="심사"
                v-model="param.suggestion.suggestionSecondAuditCd"
              >
              </c-select>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
              <c-text
                :editable="editable"
                :disabled="disabled"
                label="포상금"
                suffix="원"
                type="number"
                name="bountySecond"
                v-model="param.suggestion.bountySecond">
              </c-text>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
              <c-textarea
                :editable="editable"
                :disabled="disabled"
                :rows="16"
                label="심사의견"
                name="suggestionSecondAuditOpinion"
                v-model="param.suggestion.suggestionSecondAuditOpinion">
              </c-textarea>
            </div>
          </template>
        </c-card>
      </div>
      <c-dialog :param="popupOptions"></c-dialog>
    </q-form>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
import transactionConfig from '@/js/transactionConfig';
export default {
  name: 'suggestionSecondAudit',
  props: {
    param: {
      type: Object,
      default: () => ({
        saiSugSuggestionId: '',
        suggestion: {
          saiSugSuggestionId: '',
          suggestionStepCd: '',
          suggestionNo: '',
          plantCd: '',
          regDeptCd: '',
          execDeptCd: '',
          suggestionDate: '',
          suggestionStatus: '',
          suggestionTitle: '',
          suggestionProblem: '',
          suggestDivisionTypeCd: null,
          suggestCategoryTypeCd: null,
          suggestionSuggest: '',
          suggestionBenefit: '',
          suggestionImprove: '',
          suggestionLocation: '',
          suggestionFirstAuditCd: '',
          suggestionSecondAuditCd: '',
          suggestionFirstAuditOpinion: '',
          suggestionSecondAuditOpinion: '',
          suggestionTypeEffect: '',
          suggestionIntangibleEffect: '',
          bountyFirst: '',
          bountySecond: '',
          sysApprovalRequestId: '',
          approvalStatusCd: '',
          vendorCd: '',
          approvalRequestFlag: '',
          regUserId: '',
          chgUserId: '',
        },
      }),
    },
  },
  data() {
    return {
      saveUrl: '',
      completeUrl: '',
      editable: true,
      isSave: false,
      isComplete: false,
      
      popupOptions: {
        target: null,
        title: '',
        visible: false,
        width: '90%',
        top: '10px',
        param: {},
        closeCallback: null,
      },
    };
  },
  computed: {
    disabled() {
      return this.editable 
        && (this.$_.indexOf(this.$store.getters.auths, 'SAGI000021') === -1
        || this.param.suggestion.suggestionStepCd !== 'SSSSC00004')
    },
    disabledPrint() {
      return this.editable && this.$_.indexOf(this.$store.getters.auths, 'SAGI000021') === -1
    }
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.saveUrl = transactionConfig.sai.sug.suggestion.update.url;
      this.completeUrl = transactionConfig.sai.sug.suggestion.complete.url;
      this.printUrl = selectConfig.sai.sug.suggestion.secondPrint.url;
      // code setting
      // list setting 
    },
    saveData() {
      this.$refs['editForm'].validate().then(_result => {
        if (_result) {
          window.getApp.$emit('CONFIRM', {
            title: 'LBLCONFIRM',    // 확인
            message: 'MSGSAVE', // 저장하시겠습니까?     // 저장하시겠습니까?
            // TODO : 필요시 추가하세요.
            type: 'info', // success / info / warning / error
            // 확인 callback 함수
            confirmCallback: () => {
              this.param.suggestion.chgUserId = this.$store.getters.user.userId;
              this.isSave = !this.isSave;
            },
            // 취소 callback 함수
            cancelCallback: () => {
            },
          });
        } else {
          window.getApp.$emit('APP_VALID_ERROR');
        }
      });
    },
    saveCallback(result) {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      this.param.saiSugSuggestionId = result.data
    },
    completeData() {
      this.$refs['editForm'].validate().then(_result => {
        if (_result) { 
          window.getApp.$emit('CONFIRM', {
            title: '확인',
            message: '완료하시겠습니까?',
            // TODO : 필요시 추가하세요.
            type: 'info', // success / info / warning / error
            // 확인 callback 함수
            confirmCallback: () => {
              this.param.suggestion.chgUserId = this.$store.getters.user.userId
              this.isComplete = !this.isComplete
            },
            // 취소 callback 함수
            cancelCallback: () => {
            },
          });
        } else {
          window.getApp.$emit('APP_VALID_ERROR');
        }
      });
    },
    completeCallback() {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      this.$emit('emitStep', {
        name: 'getDetail',
        param: { 
          saiSugSuggestionId: this.param.saiSugSuggestionId
        },
      })
    },
    secondAuditPrint() {
      let thisVue = this;
      this.$http.url = this.$format(this.printUrl, this.param.saiSugSuggestionId);
      this.$http.type = 'GET';
      this.$http.request(
        _result => {
          let fileOrgNm = this.param.suggestion.suggestionTitle + '_2차심사 보고서_' + this.$comm.getToday() + '.xlsx';
          let blob = thisVue.$comm.base64ToBlob(_result.data);
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, fileOrgNm);
          } else {
            let link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = fileOrgNm;
            link.click();
          }
        }, () => { }
      );
    }
  }
};
</script>
